import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Checkbox } from "@mui/material";
import { DeliverablesService } from "../../../../../../../../../api";
import { CustomTooltip, icon, IconComponent } from "../../../../../../../../../common/components";
import { useApi } from "../../../../../../../../../common/hooks";
import styles from "./DeliverableRow.module.css";
import { DOCUMENT_STATUSES } from "../../../../../../../constants/constants";

export default function DeliverableRow({
	deliverable,
	onAllocate,
	phaseLocked = false,
	reqId,
	setSelectedCount,
	showSelected = false,
}) {
	const projectId = useSelector(({ context }) => context?.project?.id);
	const { call: selectDeliverables } = useApi(DeliverablesService.selectDeliverables);
	const { call: unselectDeliverables } = useApi(DeliverablesService.unselectDeliverables);
	const isArchived = useSelector(({ srDocument }) => srDocument.status === DOCUMENT_STATUSES.ARCHIVED);
	const [localChecked, setLocalChecked] = useState(
		deliverable.isCovered === true || deliverable.isCovered === false || false
	);
	const handleCheckboxChange = (event) => {
		const isChecked = event.target.checked;
		if (isChecked) {
			selectDeliverables({ projectId, reqId, deliverableId: deliverable.id }).then(() => {
				setSelectedCount((prev) => prev + 1);
				setLocalChecked(true);
				onAllocate(deliverable.id, true);
			});
		} else {
			unselectDeliverables({ projectId, reqId, deliverableId: deliverable.id }).then(() => {
				setSelectedCount((prev) => prev - 1);
				setLocalChecked(false);
				onAllocate(deliverable.id, false);
			});
		}
	};
	return !showSelected || (showSelected && localChecked) ? (
		<div className={`${styles.row} ${phaseLocked ? styles.locked : ""}`}>
			<Checkbox checked={localChecked} disabled={phaseLocked || isArchived} onChange={handleCheckboxChange} />
			<div className={styles.row__content} translate="no">
				<CustomTooltip showWhenOverflow title={deliverable.name}>
					<div className={styles.row__documentName}>
						{deliverable.name}
						{phaseLocked && <IconComponent color="var(--grey-600)" icon={icon.faLock} />}
					</div>
				</CustomTooltip>
				<CustomTooltip showWhenOverflow title={deliverable.ref}>
					<div className={styles.row__documentRef}>{deliverable.ref}</div>
				</CustomTooltip>
			</div>
		</div>
	) : null;
}
